var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logo-container", class: { collapse: _vm.collapse } },
    [
      _c(
        "transition",
        { attrs: { name: "logoFade" } },
        [
          _c(
            "router-link",
            { key: "collapse", staticClass: "logo-link", attrs: { to: "/" } },
            [
              _vm.logo
                ? _c("img", { staticClass: "logo", attrs: { src: _vm.logo } })
                : _vm._e(),
              _c("h1", { staticClass: "logo-title" }, [
                _vm._v(_vm._s(_vm.title) + " ")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }